import React from 'react';

const InformationOnFileDescription = (
  <>
    <p>
      You should only select <strong>Continue</strong> if 1 of these statements
      is true:
    </p>
    <ul>
      <li>
        You need to update a recent application, <strong>or</strong>
      </li>
      <li>You need to update current enrollment information</li>
    </ul>
    <p>
      If you have not applied for CHAMPVA benefits for yourself or someone else,
      go back and select <strong>A new application</strong>. You’ll also need to
      start a new application to reapply after a denial or loss of benefits.
    </p>
  </>
);

export default InformationOnFileDescription;
